import React from 'react';
import parrotfyLogo from '../../../assets/images/parrotfy-logo.svg';
import twistLogo from '../../../assets/images/twist-logo.svg';
import './styles.scss';

// Brand wordmark.
//   variant="coral"   (default) → Parrotfy logo, as authored (light backgrounds)
//   variant="white"            → Parrotfy logo inverted to white (dark/blue bg)
//   variant="twistgo"          → Twist GO logo, for the legacy Twist-flow views
//                                (delivery/driver/error) and the TwistGo onboarding
// The coral↔white pair is a single SVG inverted via CSS (no separate white asset).
// Pass `className` / `style` to size it per context.
const LOGOS = { coral: parrotfyLogo, white: parrotfyLogo, twistgo: twistLogo };

const ParrotfyLogo = ({ variant = 'coral', className = '', alt, ...rest }) => (
  <img
    src={LOGOS[variant] || parrotfyLogo}
    alt={alt || (variant === 'twistgo' ? 'Twist GO' : 'Parrotfy')}
    className={`pf-logo pf-logo--${variant} ${className}`.trim()}
    {...rest}
  />
);

export default ParrotfyLogo;
